interface Props {
  className?: string;
}

/**
 * Empty-state illustration for the channel list (creator has no channels).
 * 1:1 recreation of PopshopRN's inline `Icon` in `EmptyChannelListView` — a
 * mint-green chat bubble with text lines, a small dark bubble with a "…", and a
 * circular "!" badge. Dark-surface palette (the community dashboard is dark):
 * mint bubble = brand accent, small bubble + badge = neutral, marks = white.
 */
export function CommunityChannelsEmptyIcon({ className }: Props) {
  return (
    <svg
      viewBox="0 0 195 110"
      fill="none"
      className={className}
      role="img"
      aria-label="No community channels"
    >
      {/* Large chat bubble body */}
      <path
        d="M141.014 41.8462H36.1135C30.5385 41.8462 26.0195 46.3652 26.0195 51.9402V91.4802V107.247C26.0195 108.927 28.0655 109.753 29.2315 108.542L39.2435 98.1492C40.1345 97.2242 41.3645 96.7012 42.6485 96.7012L141.013 96.5872C145.83 96.5872 149.734 92.6822 149.734 87.8662V50.5682C149.735 45.7502 145.83 41.8462 141.014 41.8462Z"
        className="fill-brand"
      />
      {/* Text lines inside the large bubble */}
      <path
        d="M77.6395 62.5332H52.4375C51.8845 62.5332 51.4375 62.0852 51.4375 61.5332C51.4375 60.9812 51.8845 60.5332 52.4375 60.5332H77.6395C78.1925 60.5332 78.6395 60.9812 78.6395 61.5332C78.6395 62.0852 78.1925 62.5332 77.6395 62.5332Z"
        className="fill-white"
      />
      <path
        d="M131.566 62.5332H92.9855C92.4325 62.5332 91.9855 62.0852 91.9855 61.5332C91.9855 60.9812 92.4325 60.5332 92.9855 60.5332H131.566C132.119 60.5332 132.566 60.9812 132.566 61.5332C132.566 62.0852 132.118 62.5332 131.566 62.5332Z"
        className="fill-white"
      />
      <path
        d="M115.914 71.5142H52.4365C51.8835 71.5142 51.4365 71.0662 51.4365 70.5142C51.4365 69.9622 51.8835 69.5142 52.4365 69.5142H115.914C116.467 69.5142 116.914 69.9622 116.914 70.5142C116.914 71.0662 116.467 71.5142 115.914 71.5142Z"
        className="fill-white"
      />
      <path
        d="M94.4965 80.4941H52.4375C51.8845 80.4941 51.4375 80.0461 51.4375 79.4941C51.4375 78.9421 51.8845 78.4941 52.4375 78.4941H94.4965C95.0495 78.4941 95.4965 78.9421 95.4965 79.4941C95.4965 80.0461 95.0485 80.4941 94.4965 80.4941Z"
        className="fill-white"
      />
      {/* Small chat bubble body */}
      <path
        d="M7.64346 43.94H36.8695C37.8025 43.94 38.6955 44.32 39.3425 44.991L46.6135 52.539C47.4605 53.418 48.9465 52.819 48.9465 51.598V40.148V11.434C48.9465 7.38501 45.6645 4.104 41.6165 4.104H6.48148C3.18648 4.104 0.51648 6.77501 0.51648 10.069V36.812C0.51548 40.749 3.70746 43.94 7.64346 43.94Z"
        className="fill-neutral-700"
      />
      {/* "…" dots in the small bubble */}
      <path
        d="M33.5275 24.9068C33.5275 26.2888 34.6474 27.4088 36.0294 27.4088C37.4114 27.4088 38.5315 26.2888 38.5315 24.9068C38.5315 23.5248 37.4114 22.4048 36.0294 22.4048C34.6484 22.4038 33.5275 23.5248 33.5275 24.9068Z"
        className="fill-white"
      />
      <path
        d="M21.7994 24.9068C21.7994 26.2888 22.9194 27.4088 24.3014 27.4088C25.6834 27.4088 26.8034 26.2888 26.8034 24.9068C26.8034 23.5248 25.6834 22.4048 24.3014 22.4048C22.9194 22.4038 21.7994 23.5248 21.7994 24.9068Z"
        className="fill-white"
      />
      <path
        d="M9.79541 24.9068C9.79541 26.2888 10.9154 27.4088 12.2974 27.4088C13.6794 27.4088 14.7994 26.2888 14.7994 24.9068C14.7994 23.5248 13.6794 22.4048 12.2974 22.4048C10.9154 22.4038 9.79541 23.5248 9.79541 24.9068Z"
        className="fill-white"
      />
      {/* Circular "!" badge */}
      <path
        d="M169.983 73.5C183.514 59.969 183.514 38.031 169.983 24.5C156.452 10.969 134.514 10.969 120.983 24.5C107.452 38.031 107.452 59.969 120.983 73.5C134.514 87.031 156.452 87.031 169.983 73.5Z"
        className="fill-neutral-700"
      />
      <path
        d="M143.563 35.2876H147.41V55.6746H143.563V35.2876ZM143.563 58.8629H147.41V62.7093H143.563V58.8629Z"
        className="fill-white"
      />
    </svg>
  );
}
